<mat-form-field
  [appearance]="isInTableHeader ? null : 'outline'"
  [ngClass]="{ 'w-100': isFullWidth }"
>
  @if (label) {
    <mat-label>{{ label }}</mat-label>
  }
  <input
    matInput
    #sdInput
    [matDatepicker]="sdPicker"
    name="sd"
    [min]="minDate ? minDate : null"
    [max]="maxDate ? maxDate : today"
    [(ngModel)]="model"
    (dateChange)="onDateChange()"
  />
  <button
    type="button"
    mat-icon-button
    matSuffix
    color="primary"
    (click)="sdPicker.open()"
  >
    <mat-icon>today</mat-icon>
  </button>
  <mat-datepicker
    #sdPicker
    (closed)="sdInput.blur()"
    [calendarHeaderComponent]="customHeader"
  ></mat-datepicker>
</mat-form-field>
